var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',[_c('text-field',{attrs:{"rules":_vm.vs.form.name,"label":_vm.adminText('workflowsAll.referral_name_a363eb3', 'Referral name'),"autofocus":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"form.name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }